const angular = require("angular");
import ActualLogoutWarningModal from "../modals/logout-warning/logout-warning";

const WARNING_POST_MSG = "tokenExpirationWarning";
const CHECK_INTERVAL = 1000 * 60 * 5;
// Use 6 minutes so we make sure we don't miss a chance to warn
const WARNING_TIMEFRAME_IN_SECONDS = 60 * 6;
const MINIMUM_SECONDS_CONSIDERED_VALID = 60;
const NETWORK_FAILURE = "network failure";
const NETWORK_SUCCESS = "network successful";

class TokenCheck {
  public static $inject = [
    "$q",
    "$log",
    "$interval",
    "$timeout",
    "$Router",
    "$CurrentUser",
    "$IdentityResource",
    "LogoutWarningModal"
  ];

  private interval = null;

  constructor(
    private $q,
    private $log,
    private $interval,
    private $timeout,
    private $Router,
    private $CurrentUser,
    private $IdentityResource,
    private LogoutWarningModal,
    private _networkStatus = null
  ) {}

  public start = () => {
    this.cancelInterval();
    this.interval = this.$interval(this.check, CHECK_INTERVAL);
    this.check();
  };

  public restart = () => {
    this.cancelInterval();
    this.$timeout(this.LogoutWarningModal.closeAllModals, 0);
    this.interval = this.$interval(this.check, CHECK_INTERVAL);
  };

  public checkThenStop = () => {
    // Check the current token to see if it has been renewed and is now valid
    // If so, start a new interval
    // If not, stop and logout

    if (!this.$CurrentUser.token) {
      this.stop();
    }

    this.$IdentityResource
      .post("token/check/")
      .then(res => {
        if (
          res.status === "ok" &&
          res.expires_in > MINIMUM_SECONDS_CONSIDERED_VALID
        ) {
          // The token is still valid (maybe the user logged out and in again)
          // Start a new interval
          this.restart();
        } else {
          this.stop();
        }
      })
      .catch(err => {
        this.stop();
      });
  };

  public stop = () => {
    this.cancelInterval();
    if (this.$CurrentUser.token) {
      this.$CurrentUser.destroySession();
    }
    this.$timeout(this.LogoutWarningModal.closeAllModals, 0);
  };

  private check = () => {
    if (!this.$CurrentUser.token) {
      return false;
    }
    this._networkStatus = !window.navigator.onLine
      ? NETWORK_FAILURE
      : NETWORK_SUCCESS; // this isn't 100% accurate but it will help
    if (
      this.$CurrentUser.sessionExpires &&
      this._networkStatus === NETWORK_FAILURE &&
      new Date() < this.$CurrentUser.sessionExpires
    ) {
      return true;
    } else {
      this.$IdentityResource
        .post("token/check/")
        .then(res => {
          this._networkStatus = NETWORK_SUCCESS;
          var t = new Date();
          t.setSeconds(t.getSeconds() + res.expires_in * 1);
          this.$CurrentUser.sessionExpires = t;
          if (res.expires_in <= WARNING_TIMEFRAME_IN_SECONDS) {
            this.warn(res.expires_in);
            this.cancelInterval();
            this.$timeout(this.checkThenStop, res.expires_in * 1000);
          }
        })
        .catch(err => {
          this.$log.error(err);
          // check to see if session has expired or recieved a 404 (what we get with an expired token)
          if (
            (this.$CurrentUser.sessionExpires &&
            new Date() >= this.$CurrentUser.sessionExpires) ||
            (err.status && err.status === 404)
          ) {
            this.checkThenStop();
          } else {
            // the user still has a current session but the response was not what we expected so we'll pass the user until the next check
            return;
          }
        });
    }
  };

  private warn = remainingSeconds => {
    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = `0${remainingSeconds % 60}`.slice(-2);

    this.$Router.broadcast(WARNING_POST_MSG + "Last", "", {
      legacy: true
    });

    this.LogoutWarningModal.show(`${minutes}:${seconds}`);
  };

  private cancelInterval = () => {
    if (this.interval) {
      this.$interval.cancel(this.interval);
      this.interval = null;
    }
  };
}

export default angular
  .module("spsng.services.token-check", [ActualLogoutWarningModal])
  .service("TokenCheck", TokenCheck).name;
